import React, { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../../assets/scss/styles.scss";
import loadingIcon from "../../assets/img/loading_green.svg";
import { getLPCs } from "../../modules/get-lpc-options";


// form field component (a helper component)
const FormField = ({type, label, placeholder, pattern, formdata, setformdata, autofocus, formerrors, onKeyPress, formData, setFormData, inputID}) => {
    const convertToSlug = (Text) => {
        return Text.toString().toLowerCase()
                .replace(/[^\w ]+/g, '')
                .replace(/ +/g, '_');
    }
    let id = convertToSlug(label);

    const handleControlledInputChange= (e, formdata, setformdata) => {
        formdata[id] = e.target.value
        setformdata({...formdata})

        setFormData({
            ...formData,
            [`input_${inputID}`]: e.target.value,
        });
    }

    const handleKeyPress = (e) => {
        if(e.key === 'Enter') {
            e.preventDefault()
            onKeyPress()
        }
    }

    // conditional statement for <input> / <textarea>
    const renderInput = () => {
        if(autofocus === 'true') {
            autofocus = true;
        } else {
            autofocus = false;
        }

        if(type==="text"){
            return (
                <input
                    type={type}
                    id={id}
                    name={id}
                    placeholder={placeholder}
                    pattern={pattern}
                    defaultValue={formdata[label]}
                    onChange={e => handleControlledInputChange(e, formdata, setformdata)}
                    autoFocus={autofocus}
                    onKeyPress={handleKeyPress}
                />
            )
        } else if (type==="textarea") {
            return (
                <textarea
                    id={id}
                    name={id}
                    placeholder={placeholder}
                    defaultValue={formdata[label]}
                    onChange={e => handleControlledInputChange(e, formdata, setformdata)}
                    autoFocus={autofocus}
                    onKeyPress={handleKeyPress}
                />
            )
        }
    }
    return (
        <fieldset className={type === 'textarea' ? 'projectDetailsContainer' : ''}>
            <div className='form_group'>
                {/* for attribute: tell the screen reader the reference / or wrap input by label tag */}
                <label className='required' htmlFor={id} > {label.toUpperCase()} </label>
                { renderInput() }
                <p className="error">{formerrors[id]}</p>
            </div>
        </fieldset>
    )
}


// contact form component
export const ContactForm = ({ setShowModal, setOverlay, serviceFields, requestedContractor }) => {
    const initialFormData = {
        full_name: "",
        business: "",
        email: "",
        role: "",
        phone_number: "",
        LPC: "",
        project_details: "",
        optIn: true,
        services: []
    }

    const [ formdata, setformdata ] = useState(initialFormData)
    const [ formerrors, setformerrors ] = useState({})
    const recaptchaRef = useRef();
    const lpcs = getLPCs().map(j => <option value={j} key={j}> {j} </option>)
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({'input_10.1': 'optIn'});
    const [confirmationMessage, setConfirmationMessage] = useState(false);
  
    const apiKey = 'ck_1dba11b8efa080359e3e11d38bbfa0377899aee9';
    const apiSecret = 'cs_223002de709ac613e4e7149f822daf2877d453a0';
    //Gravity Forms endpoint to hit Find a Contractor Form
    const apiUrl = `/wp-json/gf/v2/forms/8`;
  
    useEffect(() => {
      //Grab form data
      const fetchForm = async () => {
        const headers = new Headers({
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Basic ' + btoa(`${apiKey}:${apiSecret}`)
        });
  
        try {
          const response = await fetch(apiUrl, { headers });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setForm(data);
          setLoading(false);
        } catch (err) {
          setError(err.message);
          setLoading(false);
        }
      };
  
      fetchForm();
    }, []);
    //Loading states while form loads
    if (loading) return <div>Loading form...</div>;
    if (error) return <div>Error loading form: {error}</div>;
    // collect checkbox (services) data
    const handleCheckboxChange= (e, s) => {
        if (s == "optIn"){
            setFormData({
                ...formData,
                [`input_10.1`]: formData['input_10.1'] == 'optIn' ? false : 'optIn',
            });
            setformdata({...formdata, optIn: formData['input_10.1'] == 'optIn' ? false : true});
        }
        else if(e.target.checked){
            formdata.services.push(s)
        } else {
            const index = formdata.services.indexOf(s)
            if (index !== -1) {
                formdata.services.splice(index, 1)
            }
        }
    }

    const handleLPCChange= (e) => {
        setformdata({...formdata, LPC: e.target.value})

        setFormData({
            ...formData,
            [`input_8`]: e.target.value,
        });
    }

    // form validation
    const validate = (formdata) => {

        const errors = {}
        const nameRegex = /^\s*([A-Za-z]{1,}([.,] |[-']| ))+[A-Za-z]+\.?\s*$/
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        if (!formdata.full_name) {
            errors.full_name = "Name is required"
        } else if (!nameRegex.test(formdata.full_name)) {
            errors.full_name = "This is not a valid name format!"
        }
        if (!formdata.business) {
            errors.business = "Business is required"
        }
        if (!formdata.email) {
            errors.email = "Email is required"
        } else if (!emailRegex.test(formdata.email)) {
            errors.email = "This is not a valid email format!"
        }
        if (!formdata.role) {
            errors.role = "Role is required"
        }
        if (!formdata.phone_number) {
            errors.phone_number = "Phone is required"
        } else if (!phoneRegex.test(formdata.phone_number)) {
            errors.phone_number = "This is not a valid phone number"
        }
        if (!formdata.LPC) {
            errors.LPC = "LPC is required"
        }
        if (!formdata.project_details) {
            errors.project_details = "Detail is required"
        }
        return errors
    }

    const closeDialog = () => {
		let body = document.body;
		let scrollY = body.style.top;
		body.style.position = '';
		body.style.top = '';
		body.style.width = '';
		body.style.paddingRight = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	};

    const gtm_tracking = () => {

        // get contractor name
        let contractorName = requestedContractor.contractor.company_name;

        // get contractor certification level
        let contractorCertification = requestedContractor.contractor.certification;

        // Add the data to the Datalayer object from Google Tag Manager
        window.dataLayer.push({
            "event": "fac-request-service-form",
            "contractor-name": contractorName,
            "contractor-certification-level": contractorCertification
        });

    };

    // submit the form
    const handleSubmit = async (e) => {
        if(e) { e.preventDefault() } // Might not have an event when passed from the keypress handler

        setformerrors(validate(formdata))

        const token = await recaptchaRef.current.execute();
        if(!Object.keys(validate(formdata)).length) {
            gtm_tracking();

            setSubmitting(true)

            try {
                let res = await fetch("/wp-json/fac/v1/submit-contact", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body:JSON.stringify( {
                        fullName: formdata.full_name,
                        companyName: formdata.business,
                        email: formdata.email,
                        title: formdata.role,
                        phone: formdata.phone_number,
                        powerCompany: formdata.LPC,
                        projectInfo: formdata.project_details,
                        optIn: formdata.optIn == true ? 1 : 0,
                        services: formdata.services,
                        recaptchaToken: token,
                        contractorEmail: requestedContractor.contractor.email
                    } ),
                });
                if (res.status === 200) {
                    console.log("email sent");
                    closeDialog();
                }
            } catch(err) {
                console.log(err);
            }
        
            //Now submit form to Gravity Forms
            try {
                const response = await fetch(`${apiUrl}/submissions`, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(`${apiKey}:${apiSecret}`)
                    },
                    body: JSON.stringify(formData),
                });
                const result = await response.json();
                if (!response.ok) {
                    alert(`Form submission failed: ${result.message}`);
                }
                setConfirmationMessage(result?.confirmation_message);
            } catch (err) {
                alert(`Error submitting form: ${err.message}`);
            }
        }
    }

    const handleKeypress = (e) => {
        if (e && e.key === 'Enter'){
            handleSubmit()
        } else {
            handleSubmit()
        }
    }

    return (
        <div className="fac-contact-form-container">
            {!confirmationMessage &&
                <>
                    <div className="fac-contact-form-header">
                        <h4>Let's get your project started.</h4>
                        <p>
                            To connect with this TVA EnergyRight Business & Industry Preferred Partner, complete the following form and click
                            "Submit request." The selected PPN contractor will contact you within 24 hours.
                        </p>
                    </div>
                    <form className="fac-contact-form">
                        {form.fields.map((field) => (
                            field.type == 'text' ? 
                            (<FormField type="text" label={field.label} placeholder={field.placeholder}
                            formdata={formdata} setformdata={setformdata} formerrors={formerrors} onKeyPress={handleKeypress} formData={formData} setFormData={setFormData}
                            inputID={field.id}
                            />) 
                            : field.type === 'select' ? (
                                <fieldset type="select" label="LPC">
                                    <div className='form_group'>
                                        <div className="service-checkbox-label-wrapper">
                                            <label className='required'>{field.label}</label>
                                            <p>{formerrors.LPC}</p>
                                        </div>
                                        <div className="lpc-dropdown-container">
                                            <select className="lpc-select" key={`servicetag${lpcs}`} defaultValue={'default'} onChange={e => handleLPCChange(e)} onKeyPress={handleKeypress}>
                                                <option value="default" key="default" disabled hidden  >Select a LPC</option>
                                                {field?.choices?.map(j => <option value={j.value} key={j.value}> {j.text} </option>)}
                                            </select>
                                        </div>
                                    </div>
                                </fieldset>
                            )
                            : field.type === 'textarea' ? (
                                <FormField type="textarea" label={field.label} placeholder={field.placeholder}
                                formdata={formdata} setformdata={setformdata} formerrors={formerrors} onKeyPress={handleKeypress} formData={formData} setFormData={setFormData}
                                inputID={field.id}
                                />
                            )
                            : field.type === 'checkbox' ? (
                                <fieldset style={{width: '85%'}}>
                                    <div className='form_group'>
                                        <div className="optin-checkbox-container">
                                            {field?.choices?.map(choice => (
                                                <div className="checkbox">
                                                    <input type="checkbox" key={choice.value} name={choice.value} id={choice.value} onChange={e => handleCheckboxChange(e, choice.value)} onKeyPress={handleKeypress} checked={formData['input_10.1'] == 'optIn'} />
                                                    <label htmlFor={choice.value} key="default">{choice.text}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </fieldset>
                            ) : null
                        ))}

                        <div className="contact-modal-buttons">
                            {!submitting &&
                                <>
                                    <button className="fac-btn fac-btn-primary contact-modal-button" type="button" onClick={handleSubmit} onKeyPress={handleKeypress}>
                                        Submit request
                                    </button>
                                    <button className="fac-btn fac-btn-secondary contact-modal-button" onClick={(e) => {
                                        e.preventDefault()
                                        setShowModal(false)
                                        setOverlay(false)
                                        closeDialog()
                                    }}>
                                        Close
                                    </button>
                                </>
                            }
                            {submitting &&
                                <>
                                    <button className="fac-btn fac-btn-primary contact-modal-button" type="button" disabled>
                                        Submitting...
                                    </button>
                                    <span data-class="loading">
                                        <img loading="lazy" class="loading" alt="Loading" src={loadingIcon} style={{height: '50px', marginLeft: '10px'}} ></img>
                                    </span>
                                </>
                            }
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="invisible"
                                sitekey="6LdU1e0UAAAAAKpj1vJA3yX1bhgrDVl8oIqzl8eA"
                            />
                        </div>
                    </form>
                </>
            }
            {confirmationMessage &&
                <div dangerouslySetInnerHTML={{ __html: confirmationMessage }} />
            }
        </div>
    )
}
